import { FAQ, Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateFAQs = generateAPI<
  {
    body: {
      faqs: FAQ[];
    };
  },
  Wedding
>("put", "wedding/faqs", "wedding/");
